import { DobInput } from '@dedalusdiit/dob-components';
import { useTranslation } from 'react-i18next';

export interface DateInputWrapperProps {
    label: string;
    onClick: () => void;
    from: Date | undefined;
    until: Date | undefined;
    preset: string | undefined;
    onReset: () => void;
};

function DateInputWrapper(props: Readonly<DateInputWrapperProps>): React.ReactElement {
    const { label, onClick, from, until, preset, onReset } = props;
    const { t } = useTranslation();

    const translatePreset = (str: string): string => {
        switch (str) {
            case 'today': return t('Today');
            case 'yesterday': return t('Yesterday');
            case '2d': return t('LastTwoDays');
            case '7d': return t('LastSevenDays');
            case '30d': return t('LastThirtyDays');
            default: {
                console.error(`Invalid preset given for translation in DateInputWrapper: ${str}`);
                return '';
            }
        }
    };

    let text = '';
    if (preset != undefined) {
        text = translatePreset(preset);
    }
    else if (from != undefined && until == undefined) {
        text = `${t('From')} ${new Date(from).toLocaleDateString('en-GB')}`;
    }
    else if (from == undefined && until != undefined) {
        text = `${t('Until')} ${new Date(until).toLocaleDateString('en-GB')}`;
    }
    else if (from != undefined && until != undefined) {
        text = `${new Date(from).toLocaleDateString('en-GB')} - ${new Date(until).toLocaleDateString('en-GB')}`;
    }

    const onValueChange = (val: string): void => {
        if (val !== '') {
            return;
        }

        onReset();
    };

    return <DobInput value={text} onValueChange={onValueChange} type="filter" label={label} onClick={onClick} />;
}

export default DateInputWrapper;
